import React from 'react';
import {Affix,Badge } from "antd";
import {imgUrlSite,baseUrl,getCookie,delSessionItem,setSessionItem,delCookie} from './service/common.js';
import LoginPopConfirm from './LoginPopConfirm.jsx';
let ws = null;
//避免重复连接
let lockReconnect = false;
let tt = null;
export default class Header extends React.Component {
    state={
        bcoutn:0,
        userInfo:{},
        noticeList:[
            {name: "system"},
            {name: "dynamic"},
            {name: "inside"},
        ]
    }
    //重连函数
    reConnect=()=>{
        if (lockReconnect) {
            return;
        }
        lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多
        tt && clearTimeout(tt);
        tt = setTimeout(function () {
            //this.connect();
            lockReconnect = false;
        }, 30000);
    }
    componentDidMount() {
        var sid = getCookie("z_sid");
        var str = window.location.href; //要截取的字符串
        var index = str.indexOf("#");
        var result = str.substr(index + 1,str.length);
        window.WebSocket = window.WebSocket || window.MozWebSocket;
        //心跳检测
        let heartCheck = {
            //每隔几秒测试一下心跳是否在继续
            timeout: 10000,
            timeoutObj: null,
            serverTimeoutObj: null,
            start: function () {
                // console.log('开始测试心跳');
                var self = this;
                this.timeoutObj && clearTimeout(this.timeoutObj);
                this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
                this.timeoutObj = setTimeout(function () {
                    //这里发送一个心跳，后端收到后，返回一个心跳消息，
                    // console.log('发送消息，测试后台是否运行中...');
                    //任意发一个消息过去，后台接收，在init()中的onmessage收到消息，说明后台没有挂掉，有心跳
                    ws.send("666");
                    self.serverTimeoutObj = setTimeout(function () {
                        // console.log("后台挂掉，没有心跳了....");
                        ws.close();
                        // createWebSocket();
                    }, self.timeout);

                }, this.timeout)
            }
        };
        if (!window.WebSocket) {
            alert("该浏览器不支持websocket");
            return;
        }else{
            if(sid) {
                React.$http.getUserInfo().then((res)=>{
                    if(res&&res.success){
                        if(res.userInfo){
                            this.setState({
                                userInfo: res.userInfo,
                            });
                            setSessionItem('userInfo',res.userInfo);  
                            if(result.split('/')[2]==='notice'){
                                this.setState({
                                    bcoutn:0
                                });
                            }else{
                                ws = new WebSocket(`${baseUrl.WebSockeUrl}/ws/connect/${res.userInfo.userId}`);
                                ws.onmessage=(evt)=> {
                                    var count = JSON.parse(evt.data).num;
                                    this.setState({
                                        bcoutn:count
                                    });
                                    // console.log("心跳...");
                                    //心跳检测重置
                                    heartCheck.start();
                                };
                    
                                ws.onclose=(evt)=> {
                                    // console.log("连接中断");
                                    this.reConnect();
                                };
                    
                                ws.onopen=(evt)=> {
                                    // console.log("连接成功");
                                    heartCheck.start();
                                };
                    
                                ws.onerror=(evt)=> {
                                    // console.log("连接失败");
                                    this.reConnect();
                                }
                                window.onbeforeunload=()=>{
                                    ws.close();
                                };
                            }
                        }
                    }
                });
            }   
        }
    }

    logout=()=>{
        this.setState({userInfo:{}});
        delCookie('z_sid');
        delCookie('userId');
        delCookie('noAlertPerfection');
        delCookie('loginTargetUrl');
        delSessionItem('userInfo');//缓存用户的登录信息
        delSessionItem('checkStep');//专家完善信息的选择身份信息
        window.location.href='/index.html';//退出返回首页
    }

    locationLogin=()=>{
        delCookie('loginTargetUrl');
        window.location.href='/account.html';
    }

    render() {
        const {userInfo,bcoutn,noticeList} = this.state;
        const sid = getCookie('z_sid');
        return (
            <div className="headerWrap">
                <Affix>
                    <div className="headfix">
                    <div className="header">
                    <div className="logo">
                        <a href="/">
                            <img src="/assets/images/logo.png" alt=""/>
                        </a>
                    </div>
                    <ul className="nav">
                        <li><a className="index" href="/index.html">首页</a></li>
                        <li><a href="/site.html" target="_blank" rel="noopener noreferrer">信息素养</a></li>
                        <li><a className="thesis" href="/thesis.html">论文推荐</a></li>
                        {/* <li><a className="interpretations" href="/interpretation.html">专家解读</a></li> */}
                        <li><a className="view" href="/view.html">图情视界</a></li>
                        {/* <li><a className="consult" href="/consult.html">问答</a></li> */}
                        {/* <li><a href="/expertonline.html" target="_blank" rel="noopener noreferrer">1对1咨询</a></li> */}
                    </ul>
                    <div className="userInfo">
                        {
                            sid?(
                                <a className="vote" href="./view.html#/pubView"><i className="ico ico-vote"></i>写文章</a>
                            ):(
                                <LoginPopConfirm
                                    button={<span className="vote"><i className="ico ico-vote"></i>写文章</span>}
                                    placement="bottomRight"
                                />
                            )
                        }
                        {/* {
                            sid?(
                                <a className="ask" href="/consult.html#/Question"><i className="ico ico-ask"></i>提问题</a>
                            ):(
                                <LoginPopConfirm
                                    button={<span className="ask"><i className="ico ico-ask"></i>提问题</span>}
                                    placement="bottomRight"
                                />
                            )
                        } */}
                        <a className="search" href="/search.html"><i className="ico ico-search"></i>搜索</a>
                        {
                            userInfo.userId?
                                bcoutn>0?
                                (
                                    <Badge count={bcoutn} overflowCount={99}>
                                        <a href={'/personal.html#/'+userInfo.userId+'/notice/'+noticeList[0].name} className="nomesg">
                                            <i className="ico emsg_icon"></i>
                                        </a>
                                    </Badge>
                                ):(
                                    <a href={'/personal.html#/'+userInfo.userId+'/notice/'+noticeList[0].name} className="mesg">
                                        <i className="ico emsg_icon"></i>
                                    </a>
                                )
                            :''
                        }
                        {
                            userInfo.userId?(
                                <div className="userHead">
                                    <div className="unames">
                                        <img src={userInfo.imgUrl?imgUrlSite+userInfo.imgUrl:'/assets/images/head1.png'} alt="头像" />
                                    </div>
                                    <div className="list">
                                        <div>
                                            <a href={'/personal.html#/'+userInfo.userId+'/index/specialcol'} >个人主页</a>
                                        </div>
                                        {/* <div>
                                            <a href="/expertonline.html#/order">我的咨询</a>
                                        </div>
                                        {
                                            userInfo.userCerts&&userInfo.userCerts.length>0?<div>
                                                <a href="/expertonline.html#/consultme">咨询我的</a>
                                            </div>:''
                                        }
                                        <div>
                                            <a href="/wallet.html#/" target="_blank">我的钱包</a>
                                        </div> */}
                                        <div><a href="/user.html">账户设置</a></div>
                                        <div onClick={this.logout}>退出登录</div>
                                    </div>
                                </div>
                            ):(<span onClick={this.locationLogin} className="login">登录</span>)
                        }
                    </div>
                </div>
                    </div>
                </Affix>
            </div>
            
        );
    }
}